import React, { useEffect, useReducer, useState } from "react";
import "./App.css";
import ContentBookList from "./modules/ContentBookList";
import ContentEmpty from "./modules/ContentEmpty";
import axios from "./wp-axios/axios";
import { ASSET_PATH } from "./utilities";
import pointer from "./shadow.svg";

const App = () => {
    const {
        wishlist_name: wishlistName,
        wishlist_max_isbn: wishlistMaxIsbn,
        wishlist_url: wishlistUrl,
        wishlist_empty_text: wishlistEmptyText,
        wishlist_bridge_login: wishlistBridgeLogin,
    } = window.prhReactWishlistSidePanel;

    // TODO: maybe combine all of these into one state?
    const [gettingData, setGettingData] = useState(false);
    const [bookData, setBookData] = useState([]);
    const [listCount, setListCount] = useState(0);
    const [containerClass, setContainerClass] = useState("");
    // eslint-disable-next-line no-unused-vars
    const [isbnData, onIsbnsChange] = useReducer(
        (existingIsbnData, newIsbns) => {
            if (newIsbns.length > 0) {
                if (
                    JSON.stringify(newIsbns) !==
                    JSON.stringify(bookData.map((book) => book.isbn))
                ) {
                    setListCount(newIsbns.length);
                    setGettingData(true);
                    axios
                        .post(`/get-isbn-book-data`, { isbns: newIsbns })
                        .then((r) => {
                            setGettingData(false);
                            setBookData(r.data.data.data);
                        });
                    return newIsbns;
                }
                return existingIsbnData;
            } else {
                setListCount(0);
                setBookData([]);
                return [];
            }
        },
        []
    );
    useEffect(() => {
        var sidePanelLoadedEvent = new CustomEvent("sidePanelLoadedEvent", {
            bubbles: true,
            detail: { test: "isbns" },
        });

        document.querySelector("body").dispatchEvent(sidePanelLoadedEvent);
    }, []);

    function onRemoveIsbn(isbn) {
        setBookData(bookData.filter((book) => book.isbn !== isbn));
        setListCount(listCount - 1);
        // TODO: rename the window function
        window.jQuery.fn.watchWishlist().saveIsbn(isbn);
        window.jQuery('[data-isbn="' + isbn + '"]').removeClass("active");
    }

    //  Send data to PHP side to get book data
    useEffect(() => {
        // Get the initial ISBNs from local storage via wishlist.js
        const existingWishlistIsbns = window.jQuery.fn
            .watchWishlist()
            .getWishlist()
            ? window.jQuery.fn
                  .watchWishlist()
                  .getWishlist()
                  .isbns.map((isbnWrapper) => isbnWrapper.value)
            : [];
        onIsbnsChange(existingWishlistIsbns);

        // Unfortunately, we cannot listen to changes in the local storage in the same window.
        // So, wishlist.js will emit a custom event every time it updates the ISBNs so we
        // can hook onto it here and get the updated list.
        window.addEventListener("updateIsbnsEvent", (e) => {
            onIsbnsChange(e.detail.isbns);
        });
    }, []);
    // Add the listener for the signedin notification
    useEffect(() => {
        document.addEventListener("userLoginStatusUpdate", (event) => {
            if (wishlistBridgeLogin && event.detail.userLoggedIn) {
                setContainerClass("signed-in");
            } else if (wishlistBridgeLogin && !event.detail.userLoggedIn) {
                setContainerClass("signed-out");
            }
        });
    }, []);
    var contentClass = "content" + wishlistBridgeLogin ? " signInEnabled" : "";

    return (
        <div className="side-panel">
            <div className={contentClass}>
                {bookData.length <= 0 && !gettingData && (
                    <ContentEmpty wishlistEmptyText={wishlistEmptyText} />
                )}
                {(bookData.length > 0 || gettingData) && (
                    <div>
                        <div class="heading">My {wishlistName}</div>
                        <ContentBookList
                            gettingData={gettingData}
                            bookData={bookData}
                            maxIsbn={wishlistMaxIsbn}
                            onRemoveIsbn={onRemoveIsbn}
                            containerClass={containerClass}
                        />
                    </div>
                )}
                <div className="wishlist-info">
                    <div className="wishlist-info-row">
                        <a href={wishlistUrl} className="view-wishlist-button">
                            <i className="fa fa-heart-o"></i>
                            <span>View {wishlistName} ({listCount})</span>
                        </a>
                    </div>
                    <div className="wishlist-info-row">
                        {/* wishlist-react-app-root gets automatically rendered by Wishlist React App */}
                        <div class="wishlist-react-app-root"></div>
                    </div>
                    {/* don't remove - the wishlist ajax won't work if there's no prhbl-login-button-container on the page */}
                    <div class="prhbl-login-button-container d-none"></div>
                </div>
            </div>
            <div className="pointer">
                <img src={ASSET_PATH + pointer} alt="" />
            </div>
        </div>
    );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js